import { usePersistedEmployeeId } from "@/src/OS/Login/usePersistedEmployeeId";
import React from "react";
import { graphql, useFragment } from "react-relay";
import { RoutineOccasionListItemAssignedEmployees_RoutineOccasion$key } from "./__generated__/RoutineOccasionListItemAssignedEmployees_RoutineOccasion.graphql";
import { ListItemAssignees } from "widgets/src/TodoListItem/TodoListItemFooter/ListItemAssignees";

export function RoutineOccasionListItemAssignedEmployees(props: {
  occasion: RoutineOccasionListItemAssignedEmployees_RoutineOccasion$key;
}) {
  const { currentEmployeeId } = usePersistedEmployeeId();
  const routineOccasion = useFragment(
    graphql`
      fragment RoutineOccasionListItemAssignedEmployees_RoutineOccasion on RoutineOccasion {
        assigned {
          id
          employee {
            id
            isLinkedToViewer
            ...ListItemAssignees_employees
          }
          assignedAt
        }
        assignedRoles {
          role {
            ...ListItemAssignees_roles
          }
        }
      }
    `,
    props.occasion
  );
  const employees = routineOccasion.assigned
    .filter((e) => e != null)
    .flatMap((e) => (e.employee ? [e.employee] : []));

  const roles = routineOccasion.assignedRoles
    .filter((r) => r != null && r.role != null)
    .map((r) => r.role);

  if (employees.length === 0 && roles.length === 0) {
    return null;
  }

  return (
    <ListItemAssignees
      employees={employees}
      roles={roles}
      currentEmployeeId={currentEmployeeId ?? undefined}
    />
  );
}
